import { Page } from "@/components/Page";
import { PageHero } from "@/components/PageHero";
import { ConditionsSection } from "@/components/ConditionsSection";
import { AppointmentSection } from "@/components/AppointmentSection";
import { STOCK } from "@/data/site";

export default function Conditions() {
  return (
    <Page>
      <PageHero
        crumb="Conditions"
        overline="How We Can Help"
        title={"Conditions\nWe Support"}
        subtitle="Assessment, management and rehabilitation for a wide range of physiotherapy, speech and hearing concerns — for children and adults."
        image={STOCK.backPain}
      />
      <ConditionsSection />
      <AppointmentSection />
    </Page>
  );
}
